// Chrome用.
import React, { FC } from 'react';
import BaseBrowser from './BaseBrowser';
import { User } from '../../../constants/UserListField';
import { ResponseData } from '../../../constants/HomeVisit';

const RenderCSS = () => {
  return <style type="text/css">{'table, th, td { border: 2px solid #111 }'}</style>;
};

interface ChromeProps {
  user: User;
  homeVisit: ResponseData;
}

// Chrome.
const Chrome: FC<ChromeProps> = ({ user, homeVisit }) => {
  return (
    <>
      <BaseBrowser user={user} homeVisit={homeVisit} />
      <RenderCSS />
    </>
  );
};

export default Chrome;
